<template>
  <div class="min-h-screen flex items-center justify-center bg-[var(--color-brand-primary-darker)] py-12 px-4 relative overflow-hidden">
    <!-- Background glow effects -->
    <div class="absolute top-0 end-0 w-96 h-96 bg-[var(--color-brand-secondary)] rounded-full blur-[120px] opacity-10 translate-x-1/2 -translate-y-1/2"></div>
    <div class="absolute bottom-0 start-0 w-80 h-80 bg-[var(--color-brand-secondary-light)] rounded-full blur-[100px] opacity-10 -translate-x-1/2 translate-y-1/2"></div>

    <!-- Language switcher - fixed position -->
    <div class="fixed top-4 end-4 z-50">
      <LanguageSwitcher />
    </div>

    <div class="max-w-md w-full relative">
      <!-- Logo and branding -->
      <div class="text-center mb-8">
        <img src="/brand/symbol-on-dark.svg" alt="" class="h-16 w-16 mx-auto mb-4" />
        <p class="text-[10px] font-medium tracking-[0.2em] uppercase text-[var(--color-brand-primary-light)] mb-3">
          {{ $t('common.welcomeTo') }}
        </p>
        <h1 class="font-display text-3xl font-bold text-white tracking-wide">
          ALNAKIB<span class="text-[var(--color-brand-secondary)]">4</span>TRADE
        </h1>
        <div class="w-12 h-px bg-[var(--color-brand-secondary)] mx-auto mt-4"></div>
      </div>
      <slot />
    </div>
  </div>
</template>
